<template>
  <div id="horario">

    <vx-card v-if="therapists.length == 0">
        <div class="text-center">
            Spa não disponível para marcação de horários.
        </div>
    </vx-card>
    <div v-else>
        <vs-row vs-type="flex" vs-justify="space-between" vs-w="12">
            <vs-col  vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-lg="3"  vs-xs="12">
                <vs-button @click="newEvent" color="primary" type="filled">+ Novo</vs-button>
            </vs-col>

            <vs-col class="custom1" vs-type="flex" vs-justify="flex-end" vs-align="center" vs-lg="9"  vs-xs="12">

                <vs-button @click="changeCalendarView('monthly')" color="primary" type="filled" class="mr-2">Mês</vs-button>
                <vs-button @click="changeCalendarView('daily')"   color="primary" type="filled" class="mr-2">Dia</vs-button>

                <div v-if="calendarType == 'daily'" style="display: flex; align-items: center;">
                    <datepicker placeholder="Selecionar Data" :disabledDates="disabledDates" v-model="jumpDate" > </datepicker>
                    &nbsp;&nbsp;

                    <vs-button class="bt1_back" v-if="disButtonBack" v-on:click="move_days(-1)" radius color="primary" type="filled" icon-pack="feather" icon="icon-chevron-left" disabled>
                    </vs-button>

                    <vs-button v-else v-on:click="move_days(-1)" radius color="primary" type="filled" icon-pack="feather" icon="icon-chevron-left" >
                    </vs-button>

                    &nbsp;<h3>{{calendarDate}}&nbsp;</h3>

                    <vs-button class="bt1_back" v-on:click="move_days(1)" radius color="primary" type="filled" icon-pack="feather" icon="icon-chevron-right">
                    </vs-button>
                </div>

                <div v-if="calendarType == 'monthly'" style="display: flex; align-items: center;">
                    <datepicker placeholder="Selecionar Data" :disabledDates="disabledDates" v-model="jumpDate" > </datepicker>
                    &nbsp;&nbsp;

                    <vs-button class="bt1_back" v-if="disButtonBack" v-on:click="move_month(-1)" radius color="primary" type="filled" icon-pack="feather" icon="icon-chevron-left" disabled>
                    </vs-button>

                    <vs-button v-else v-on:click="move_month(-1)" radius color="primary" type="filled" icon-pack="feather" icon="icon-chevron-left" >
                    </vs-button>

                    &nbsp;<h3>{{calendarDate}}&nbsp;</h3>

                    <vs-button class="bt1_back" v-on:click="move_month(1)" radius color="primary" type="filled" icon-pack="feather" icon="icon-chevron-right">
                    </vs-button>
                </div>
            </vs-col>
        </vs-row>

        <br/>

        <div v-show="calendarType == 'daily'">
            <DayPilotScheduler id="dp" :config="config" ref="scheduler" />
        </div>
        <div v-show="calendarType == 'monthly'">
            <DayPilotMonth id="month-view" :config="configMonth" :events="events" ref="month" />
        </div>
    </div>

      <vs-popup :active.sync="showModal" :title="title" @close="closepop" fullscreen>

            <br>

            <vs-row vs-w="12" class="mb-5">

                <!-- Terapeuta -->
                <vs-col vs-lg="4" vs-sm="12" vs-xs="12">

                    <h5 class="mb-3">Terapeuta</h5>

                    <v-select v-if="resources.length > 0" class="selectExample" placeholder="---"
                        v-model="rowSelected.therapist_id" name="therapist_id" v-validate="'required'" width="360px"
                        label="name" :clearable="false" :disabled="editScheduleEvent" :options="therapists" style="min-width:195px">
                    </v-select>

                    <v-select v-else class="selectExample" placeholder="" v-model="rowSelected.therapist_id"
                        name="therapist_id" v-validate="'required'" width="360px">
                    </v-select>

                    <p class="text-danger text-sm" v-show="errors.has('therapist_id')">
                        {{ errors.first('therapist_id') }}
                    </p>

                </vs-col>

                <!-- Data Início -->

                <vs-col vs-lg="4" vs-sm="6" vs-xs="12">

                    <h5 class="mb-3">Data Início</h5>

                    <datepicker :format="datepickerFormat" :minimumView="'day'" :maximumView="'month'"
                        :disabledDates="disabledDates" :disabled="editScheduleEvent" v-model="rowSelected.start_date" @input="selectEndDate"
                        name="start_date" v-validate="'required'" style="z-index:202;" placeholder="YYYY-MM-DD">
                    </datepicker>

                    <p class="text-danger text-sm" v-show="errors.has('start_date')">
                        {{ errors.first('start_date') }}
                    </p>

                </vs-col>

                <!-- Data Fim -->

                <vs-col vs-lg="4" vs-sm="6" vs-xs="12">

                    <h5 class="mb-3">Data Fim</h5>

                    <datepicker :format="datepickerFormat" :disabled="editScheduleEvent" :minimumView="'day'" :maximumView="'month'"
                        :disabledDates="disabledDates2" v-model="rowSelected.end_date" name="end_date"
                        v-validate="'required'" style="z-index:201;" placeholder="YYYY-MM-DD">
                    </datepicker>

                    <p class="text-danger text-sm" v-show="errors.has('end_date')">
                        {{ errors.first('end_date') }}
                    </p>

                </vs-col>

            </vs-row>

            <br>

            <!-- ===================================== -->
            <!-- Dias da Semana -->
            <!-- ===================================== -->

            <vs-row vs-w="12" class="mb-5">
                <vs-col vs-type="flex" vs-lg="12" vs-sm="12" vs-xs="12">
                    <h5 class="mb-3">Dias da Semana</h5>
                </vs-col>
                <vs-col vs-type="flex" vs-lg="12" vs-sm="12" vs-xs="12">

                    <vs-checkbox v-model="rowSelected.weekDays" vs-value="1" class="mr-5" :disabled="editScheduleEvent" >
                        <span class="ml-2">2ª</span>
                    </vs-checkbox>

                    <vs-checkbox v-model="rowSelected.weekDays" vs-value="2" class="mr-5" :disabled="editScheduleEvent" >
                        <span class="ml-2">3ª</span>
                    </vs-checkbox>

                    <vs-checkbox v-model="rowSelected.weekDays" vs-value="3" class="mr-5" :disabled="editScheduleEvent" >
                        <span class="ml-2">4ª</span>
                    </vs-checkbox>

                    <vs-checkbox v-model="rowSelected.weekDays" vs-value="4" class="mr-5" :disabled="editScheduleEvent" >
                        <span class="ml-2">5ª</span>
                    </vs-checkbox>

                    <vs-checkbox v-model="rowSelected.weekDays" vs-value="5" class="mr-5" :disabled="editScheduleEvent" >
                        <span class="ml-2">6ª</span>
                    </vs-checkbox>

                    <vs-checkbox v-model="rowSelected.weekDays" vs-value="6" class="mr-5" :disabled="editScheduleEvent" >
                        <span class="ml-2">Sábado</span>
                    </vs-checkbox>

                    <vs-checkbox v-model="rowSelected.weekDays" vs-value="7" class="mr-5" :disabled="editScheduleEvent" >
                        <span class="ml-2">Domingo</span>
                    </vs-checkbox>

                </vs-col>

            </vs-row>

            <br>
            <hr>
            <br>
            <!-- ===================================== -->
            <!-- Horários -->
            <!-- ===================================== -->

            <vs-row vs-w="12">

                <!-- Horário de Trabalho -->

                <vs-col vs-lg="6" vs-sm="12" vs-xs="12">

                    <h4>Horário de Trabalho</h4>
                    </br>
                    <vs-row>

                        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">

                            <h5 class="mb-3">Hora Início</h5>

                            <flat-pickr :config="configdateTimePicker" placeholder="HH:MM" value=""
                                v-model="rowSelected.start_time" name="start_time" v-validate="'required'" />

                            <p class="text-danger text-sm" v-show="errors.has('start_time')">
                                {{ errors.first('start_time') }}
                            </p>

                        </vs-col>

                        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">

                            <h5 class="mb-3">Hora Fim</h5>

                            <flat-pickr :config="configdateTimePicker" placeholder="HH:MM" value=""
                                v-model="rowSelected.end_time" name="end_time" v-validate="'required'" />

                            <p class="text-danger text-sm" v-show="errors.has('end_time')">
                                {{ errors.first('end_time') }}
                            </p>

                        </vs-col>

                    </vs-row>

                </vs-col>

                <!-- Intervalo -->

                <vs-col vs-lg="6" vs-sm="12" vs-xs="12">

                    <h4>Intervalo de Almoço</h4>
                    </br>
                    <vs-row>

                        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">

                            <h5 class="mb-3">Hora Início</h5>

                            <flat-pickr :config="configdateTimePicker" placeholder="HH:MM" value=""
                                v-model="rowSelected.lunch_start_time" name="lunch_start_time" />

                            <p class="text-danger text-sm" v-show="errors.has('lunch_start_time')">
                                {{ errors.first('lunch_start_time') }}
                            </p>

                        </vs-col>

                        <vs-col vs-lg="6" vs-sm="6" vs-xs="12">

                            <h5 class="mb-3">Duração</h5>

                            <v-select class="selectExample" placeholder="---"
                                v-model="rowSelected.lunch_event" name="lunch_event" width="360px"
                                label="name" :clearable="false" :options="lunch_events" style="min-width:195px">
                            </v-select>

                            <p class="text-danger text-sm" v-show="errors.has('lunch_event')">
                                {{ errors.first('lunch_event') }}
                            </p>

                        </vs-col>

                    </vs-row>

                </vs-col>

            </vs-row>

            <br>
            <hr>
            <br>
            <!-- ===================================== -->
            <!-- Observações -->
            <!-- ===================================== -->

            <vs-row vs-w="12">

                <vs-col vs-lg="12" vs-sm="12" vs-xs="12">

                    <h5 class="mb-3">Observações</h5>

                    <vs-textarea v-model="rowSelected.observations" height="180" />

                </vs-col>

            </vs-row>

            <br>

            <!-- ===================================== -->
            <!-- Botões -->
            <!-- ===================================== -->

            <vs-row vs-w="12" vs-type="flex" vs-justify="center">

                <vs-button v-if='editScheduleEvent' @click="editTherapistSchedule()" class="mr-3" icon-pack="feather" icon="icon-check-circle">
                    Editar
                </vs-button>

                <vs-button v-if='editScheduleEvent' color="warning" type="border" class="mr-3" @click="clearEditFields" icon-pack="feather"
                    icon="icon-delete">
                    Limpar
                </vs-button>

                <vs-button v-if='!editScheduleEvent' @click="addtherapistschedule()" class="mr-3" icon-pack="feather" icon="icon-check-circle">
                    Novo
                </vs-button>

                <vs-button v-if='!editScheduleEvent' color="warning" type="border" class="mr-3" @click="clearFields" icon-pack="feather"
                    icon="icon-delete">
                    Limpar
                </vs-button>

            </vs-row>

            <br><br>

        </vs-popup>

  </div>
</template>

<style>
    .month_default_event_inner{
        border-left: 3px solid rgba(var(--vs-primary),1);
    }

    .vs-popup--content{
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        height: 100%;
    }

    hr {
        color: rgba(60, 60, 60, 0.26);
        border-color: rgba(0, 0, 0, 0.1);
        border-bottom: 0;
        width: calc(100% - 25px);
        margin: auto;
    }
</style>

<script>

import {DayPilot, DayPilotScheduler, DayPilotMonth} from 'daypilot-pro-vue'
import Vue from 'vue'

import themeConfig from '@/../themeConfig.js';

import axios from 'axios';

import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import moment from 'moment';

import { Validator } from 'vee-validate';


const dict = {
  custom: {
    therapist_id: {
      required: 'Campo Obrigatório ',
    },
    start_date: {
      required: 'Campo Obrigatório ',
    },
    start_time: {
      required: 'Campo Obrigatório ',
    },
    end_date: {
      required: 'Campo Obrigatório ',
    },
    end_time: {
      required: 'Campo Obrigatório ',
    },
    lunch_start_time: {
        required: 'Campo Obrigatório ',
    },
    lunch_event: {
        required: 'Campo Obrigatório ',
    },
  }
};

Validator.localize('pt', dict);

export default {
    name: 'horario',
    props: [
        'spaSelected',
        'spaInitial',
    ],

    data() {
        return {

            disabledDates: {
                to: new Date(Date.now() - 864e5),
            },

            disabledDates2: {
                to: new Date(Date.now() - 864e5),
                from : '',
            },
            configdateTimePicker: {
                enableTime: true,
                enableSeconds: false,
                noCalendar: true,
                time_24hr: true,
                defaultHour	: '00',
                minTime: "",
                maxTime: "",
            },

            lunch_events: [],
            config : {},
            configMonth : {},
            disButtonBack: true,
            jumpDate: '',
            spa_id: '',
            title: '',
            showModal: false,
            startDate: DayPilot.Date.today(),

            resources: [],
            therapists: [],
            events: [],

            rowSelected: {
                start_time : '',
                weekDays: ["1","2","3","4","5","6","7"],
                lunch_event: null,
                event_schedule_id: null,
            },

            editScheduleEvent: false,
            editScheduleEventID: null,
            explorationSpaSelected: '',
            calendarType: 'monthly',
        }
    },

    components: {
        DayPilotScheduler,
        DayPilotMonth,
        Datepicker,
        flatPickr,
    },

    methods: {

        datepickerFormat(date){
            return moment(date).format('YYYY-MM-DD');
        },

        selectEndDate(val) {
            this.disabledDates2.to = new Date(this.rowSelected.start_date);
        },

        newEvent() {
            this.title ='Novo Horário';

            this.$validator.reset();

            this.disabledDates.to = new Date(Date.now() - 864e5) ;

            this.spa_id =  this.$store.state.selectedSpa.spa_id;

            this.showModal = true;
        },

        editEvent(){
            this.title ='Editar Horário';

            this.$validator.reset();

            this.disabledDates.to = new Date(Date.now() - 864e5) ;

            this.spa_id =  this.$store.state.selectedSpa.spa_id;

            this.showModal = true;
        },

        move_days(val) {
            this.config.startDate = this.config.startDate.addDays(val);
            this.configMonth.startDate = this.config.startDate;
            this.jumpDate = '';

            this.disabledDates.to = new Date(Date.now() - 864e5) ;

            if(this.calendarDate != DayPilot.Date.today().toString("d MMM yyyy")){
                this.disButtonBack = false;
            }else{
                this.disButtonBack = true;
            }

            let date = DayPilot.Date(this.config.startDate).toString("yyyy-MM-dd");
            this.loadEvents(this.spaInitial,date);
        },

        move_month(val){
            this.configMonth.startDate = this.configMonth.startDate.addMonths(val);
            this.config.startDate = this.configMonth.startDate;

            this.jumpDate = '';

            this.disabledDates.to = new Date(Date.now() - 864e5) ;

            if(this.calendarDate != DayPilot.Date.today().toString("d MMM yyyy")){
                this.disButtonBack = false;
            }else{
                this.disButtonBack = true;
            }

            let firstDayOfMonth = new DayPilot.Date(
                new DayPilot.Date(this.configMonth.startDate).toString("yyyy-MM") + "-01"
            );

            let date = firstDayOfMonth.toString("yyyy-MM-dd");
            this.loadEvents(this.spaInitial,date);
        },

        closepop(){
            this.showModal = false;

            this.disabledDates.to = new Date(Date.now() - 864e5) ;

            this.editScheduleEvent = false;

            this.$validator.reset();
        },

        loadResources(currentSpa, date = DayPilot.Date.today().toString("yyyy-MM-dd") ) {
            let that = this;

            this.$vs.loading();

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/therapists/bySpaSchedule/' + currentSpa,
                params: {
                    temp_worker: true,
                    token: window.localStorage.getItem('usertoken'),
                }
            }).then(function (res){
                if(res.status == 200){

                    that.therapists = res.data.filter(el => el.status == 1 && el.deleted == 0);

                    that.resources = that.therapists;

                    that.loadSpaWorkingTime(currentSpa);

                    Vue.set(that.config, "resources", that.resources);

                    that.loadEvents(currentSpa,date);
                }
            }).catch( function (err) {
                console.log(err);
            }).then(function(){
                that.$vs.loading.close();
            });
        },

        loadEvents(currentSpa,date) {
            let that = this;

            let data = {
                'date' : date,
                'action' : 'schedules'
            };

            this.$vs.loading();

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/therapist/schedule/events/' + currentSpa + '?token='+window.localStorage.getItem('usertoken'),
                params: {
                    search: data,
                }
            }).then(function (res) {
                if(res.status == 200){

                    that.events=res.data;
                    var event_object = res.data.map(function(item) {
                        var horaInicio = item.start.split(' ')[1].substring(0, 5) + 'h';
                        var horaFim = item.end.split(' ')[1].substring(0, 5) + 'h';

                        return {
                            id: item.id,
                            start: item.start.replace(' ', 'T'),
                            end: item.end.replace(' ', 'T'),
                            resource: item.resource,
                            barColor: item.color,
                            html: "<span style='font-weight: bold;'>" + item.resource_name + "</span><br><i style='font-size: 11px;'>" + horaInicio + " - " + horaFim +"</i>",
                            observations: item.observations,
                            event_schedule_id: item.event_schedule_id,
                        };
                    });

                    Vue.set(that.configMonth, "events", event_object);
                    Vue.set(that.config, "events", that.events);
                }
            }).catch( function (err) {
                console.log(err);
            }).then(function(){
                that.$vs.loading.close();
            });
        },

        loadLunchEvents() {
            let that = this;

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/lunch-events',
                params : {
                    token: window.localStorage.getItem('usertoken')
                }
            }).then(function (res) {
                that.lunch_events = Array.from(res.data);
            })
            .catch( function (err) {
                console.log(err);
            });
        },

        addtherapistschedule(){
            this.$validator.validateAll().then(result => {
                if (result){
                    let that = this;

                    let session = JSON.parse(window.localStorage.getItem('userSession'));

                    let turnoInicio = this.rowSelected.start_time;
                    let turnoFim = this.rowSelected.end_time;

                    let almocoInicio = this.rowSelected.lunch_start_time;

                    this.rowSelected.spa_id = this.spaInitial;
                    this.rowSelected.user_id = session.id;

                    let y = DayPilot.Date.today().addHours(turnoFim.substring(0,2)).addMinutes(turnoFim.substring(3,5)) ;
                    let tmp = DayPilot.Date(y).addHours(-turnoInicio.substring(0,2)).addMinutes(-turnoInicio.substring(3,5)).toString("HH:mm");

                    if(turnoFim <= turnoInicio ){
                        that.notify('O horário de fim do turno deve ser superior ao horário de inicio de turno', 'red', 4);
                        return false;
                    }

                    if ( almocoInicio != '' && (almocoInicio < turnoInicio) ) {
                        that.notify('O intervalo de Almoço tem de estar contido no horário de trabalho', 'red', 4);
                        return false;
                    }

                    if(tmp.substring(0,2) == 0 && tmp.substring(3,5) < 30){
                        that.notify('O tempo mínimo de um turno deve ser de 30 minutos', 'red', 4);
                        return false;
                    }

                    that.$vs.loading();
                    axios({
                        method: 'post',
                        url: themeConfig.apiurl + '/spa/therapist/schedule/new',
                        data: {
                            therapistschedule: this.rowSelected,
                            token: window.localStorage.getItem('usertoken'),
                        }
                    }).then(function (res) {
                        if(res.status == 200){

                            let date = DayPilot.Date(that.config.startDate).toString("yyyy-MM-dd");
                            if(that.calendarType == 'monthly'){
                                let firstDayOfMonth = new DayPilot.Date(
                                    new DayPilot.Date(that.configMonth.startDate).toString("yyyy-MM") + "-01"
                                );

                                date = firstDayOfMonth.toString("yyyy-MM-dd");
                            }

                            that.loadEvents(that.spaInitial,date)

                            that.notify('Horário registado com sucesso', 'green');

                            that.showModal = false;
                        }
                    }).catch( function (err) {
                        that.$vs.notify({title:'',text: err.response.data.message ,color:'Red',
                                    position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:5000,});
                    }).then(function(){
                        that.$vs.loading.close();
                    });
                }
            });
        },

        editTherapistSchedule(){

            this.$validator.validateAll().then(result => {
                if (result){
                    let session = JSON.parse(window.localStorage.getItem('userSession'));

                    let turnoInicio = this.rowSelected.start_time;
                    let turnoFim = this.rowSelected.end_time;

                    let almocoInicio = this.rowSelected.lunch_start_time;
                    let almocoFim = this.rowSelected.lunch_end_time;

                    this.rowSelected.spa_id = this.spaInitial;
                    this.rowSelected.user_id = session.id;

                    let y = DayPilot.Date.today().addHours(turnoFim.substring(0,2)).addMinutes(turnoFim.substring(3,5)) ;
                    let tmp = DayPilot.Date(y).addHours(-turnoInicio.substring(0,2)).addMinutes(-turnoInicio.substring(3,5)).toString("HH:mm");

                    if(turnoFim <= turnoInicio ){
                        this.notify('O horário de fim do turno deve ser superior ao horário de inicio de turno', 'red', 4);
                        return false;
                    }

                    if(almocoFim <= almocoInicio ){
                        this.notify('O horário de fim de Almoço tem de ser superior ao horário de início', 'red', 4);
                        return false;
                    }

                    if ( almocoInicio != '' && (almocoInicio < turnoInicio) ) {
                        this.notify('O intervalo de Almoço tem de estar contido no horário de trabalho', 'red', 4);
                        return false;
                    }

                    if(tmp.substring(0,2) == 0 && tmp.substring(3,5) < 30){
                        this.notify('O tempo mínimo de um turno deve ser de 30 minutos', 'red', 4);
                        return false;
                    }

                    this.$vs.loading();
                    axios({
                        method: 'post',
                        url: themeConfig.apiurl + '/spa/therapist/schedule/edit/' + this.editScheduleEventID.id,
                        data: {
                            therapistschedule: this.rowSelected,
                            token: window.localStorage.getItem('usertoken'),
                        }
                    }).then( (res) => {
                        if(res.status == 200){
                            let date = DayPilot.Date(this.config.startDate).toString("yyyy-MM-dd");
                            if(this.calendarType == 'monthly'){
                                let firstDayOfMonth = new DayPilot.Date(
                                    new DayPilot.Date(this.configMonth.startDate).toString("yyyy-MM") + "-01"
                                );

                                date = firstDayOfMonth.toString("yyyy-MM-dd");
                            }
                            
                            this.loadEvents(this.spaInitial,date);

                            this.notify('Horário registado com sucesso', 'green');

                            this.showModal = false;
                        }
                    }).catch( (err) => {
                        this.$vs.notify({title:'',text: err.response.data.message ,color:'Red',
                                    position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:5000,});
                    }).then(() => {
                        this.editScheduleEvent   = false;
                        this.editScheduleEventID = null;
                        this.$vs.loading.close();
                    });
                }
            });
        },

        clearFields(){
            Object.keys(this.rowSelected).forEach(k =>  this.rowSelected[k] = '');
            this.editScheduleEvent = false;
            this.rowSelected.weekDays = ["1","2","3","4","5","6","7"];
        },

        clearEditFields(){
            this.rowSelected.start_time  = '';
            this.rowSelected.end_time    = '';
            this.rowSelected.lunch_event   = '';
            this.rowSelected.lunch_start_time   = null;
        },

        loadSpaWorkingTime(currentSpa){
            let that = this;

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/schedule/worktime/' + currentSpa + '?token='+window.localStorage.getItem('usertoken'),
            }).then(function (res){
                if(res.status == 200){
                    that.config.businessBeginsHour = res.data.opening_time;
                    that.config.businessEndsHour = res.data.closing_time;

                    that.configdateTimePicker.minTime = res.data.min_time;
                    that.configdateTimePicker.maxTime = res.data.max_time;
                    that.spa_close_time =  res.data.max_time;

                    that.min_time_picker = res.data.min_time;
                }
            }).catch( function (err) {
                console.log(err);
            });
        },

        cancelEvent(event) {
            let that = this;

            axios({
                method: 'delete',
                url: themeConfig.apiurl + '/spa/therapist/schedule/event/remove/' + event.data.id,
                data: {
                    token: window.localStorage.getItem('usertoken'),
                }
            }).then(function (res) {
                if(res.status == 200){
                    if(res.data == 'ERROR1') {
                        that.notify('Não é possivel remover o turno pois existem eventos marcados', 'red');
                    }else if(res.data == 'ERROR2') {
                        let tmp2 = that.scheduler.events.find(event.data.id);
                        that.scheduler.events.remove(tmp2).queue();

                        let month_view = that.$refs.month.control.events.find(event.data.id);
                        that.$refs.month.control.events.remove(month_view).queue();

                        that.notify('O turno já tinha sido removido');
                    }else{
                        let tmp2 = that.scheduler.events.find(event.data.id);
                        that.scheduler.events.remove(tmp2).queue();

                        let month_view = that.$refs.month.control.events.find(event.data.id);
                        that.$refs.month.control.events.remove(month_view).queue();

                        that.notify('Horário removido com sucesso', 'green');
                    }
                }
            }).catch( function (err) {
                console.log(err);
            });
        },

        checkSpaExploration(spa_id, popup = true) {
            let that = this;

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/check/spa/exploration' + '?token='+window.localStorage.getItem('usertoken'),
                params : {
                    spa_id : spa_id,
                }
            }).then(function (res) {
                if(res.status == 200){
                    if(popup){
                        if(res.data == '1'){
                            that.showModal = true;
                        }else{
                            that.$vs.notify({title:'',text: 'Só é possível inserir horários para SPA’s de exploração.',color:'Red',
                                position:'top-center',iconPack: 'feather',icon:'icon-alert-circle',time:4000,});
                        }
                    }
                    that.explorationSpaSelected = res.data;
                }
            })
            .catch( function (err) {
                console.log(err);
            });
        },

        changeCalendarView(calendar_type){
            this.calendarType = calendar_type;
        },

        loadTherapistWorkDay(therapist_schedule_id) {
            this.editScheduleEventID = therapist_schedule_id;

            this.$vs.loading();
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/therapist/schedule/event/' + therapist_schedule_id.id,
                params: {
                    token: window.localStorage.getItem('usertoken')
                }
            }).then( (res) => {
                this.editScheduleEvent = true;

                let lunhc_schedule_time = null;
                let lunch_start_time    = null;

                let therapist_id   = res.data.therapist_id;
                let lunch_event_id = (res.data.event_schedule && res.data.event_schedule.event_id) ? res.data.event_schedule.event_id : null;
                let lunch_event_schedule_id = (res.data.event_schedule && res.data.event_schedule.event_schedule_id) ? res.data.event_schedule.event_schedule_id : null;
                let observations   = res.data.observations;

                // Work schedule
                let work_schedule_start = new DayPilot.Date(res.data.start_date);
                let work_schedule_end   = new DayPilot.Date(res.data.end_date);

                let date = work_schedule_start.toString("yyyy-MM-dd");

                let start_time = work_schedule_start.toString("HH:mm");
                let end_time   = work_schedule_end.toString("HH:mm");

                // Lunch time
                if( lunch_event_id ){
                    lunhc_schedule_time = new DayPilot.Date(res.data.event_schedule.start_time);
                    lunch_start_time = lunhc_schedule_time.toString("HH:mm");
                }

                this.editEvent();

                this.rowSelected.start_date        = date;
                this.rowSelected.end_date          = date;
                this.rowSelected.start_time        = start_time;
                this.rowSelected.end_time          = end_time;
                this.rowSelected.lunch_start_time  = lunch_start_time;
                this.rowSelected.observations      = observations;
                this.rowSelected.event_schedule_id = lunch_event_schedule_id;

                this.rowSelected.therapist_id =
                    this.therapists.find(t => t.id == therapist_id);

                if( lunch_event_id ){
                    this.rowSelected.lunch_event =
                    this.lunch_events.find(e => e.event_id == lunch_event_id);
                }

            }).catch( (err) => {
                console.log(err);
            }).then( () => {
                this.$vs.loading.close();
            });
        },
    },

    mounted() {
        if(this.spaInitial !== 0 && this.spaInitial !== null) {
            this.resources = this.$store.state.listTherapistsBySpa;
            this.therapists= this.resources.filter(el => el.status == 1);

            if(this.resources.length === 0) {
                this.loadResources(this.spaInitial);

            } else {
                this.closepop();

                this.loadSpaWorkingTime(this.spaInitial);

                Vue.set(this.config, "resources", this.resources);

                let date = DayPilot.Date(this.config.startDate).toString("yyyy-MM-dd");

                this.loadEvents(this.spaInitial,date);
            }
        }
    },

    created() {
        let that = this;

        this.config = {
            locale: "pt-br",
            cellWidthSpec: "Auto",
            timeHeaders: [{"groupBy":"Day","format":"dddd, d MMMM yyyy"},{"groupBy":"Hour"},{"groupBy":"Cell","format":"mm"}],
            scale: "CellDuration",
            cellDuration: 10,
            days: 1,
            startDate: DayPilot.Date.today(),
            showNonBusiness: false,
            businessWeekends: true,
            eventHeight: 80,
            businessBeginsHour: '09',
            businessEndsHour: '21',
            timeRangeSelectedHandling: "Enabled",
            borderColor: '#666666',
            cellBackColor: '#ffffff',

            eventMoveHandling: "Disabled",
            eventResizeHandling: "Disabled",

            onBeforeEventRender: function(args) {
                args.data.barColor = args.data.color;

                args.data.html = args.data.start.value.substring(11, 16) + ' - ' + args.data.end.value.substring(11, 16);

                if(args.data.observations !== '' && args.data.observations !== undefined)
                {
                    args.html +="<br/>" + args.data.observations ;
                }

                args.data.areas = [
                    {
                        top: 6,
                        right: 2,
                        icon: "fa fa-sort-down",
                        visibility: "Visible",
                        action: "ContextMenu",
                        style: "font-size: 12px; background-color: #f9f9f9; border: 1px solid #ccc; padding: 2px 2px 0px 2px; cursor:pointer;"
                    }
                ];
            },

            onEventClick: (args) => {
                this.loadTherapistWorkDay(args.e.data);
            },

            contextMenu: new DayPilot.Menu({
                showMenuTitle : false,
                menuTitle: 'Opções',
                hideOnMouseOut: true,
                items: [
                    {
                        text: "Remover",
                        icon: "fa fa-trash",
                        onClick: function(args)
                        {
                            let e = args.source;
                            that.cancelEvent(e);
                        }
                    },
                ],
            })
        };

        this.configMonth = {
            locale: "pt-br",
            startDate: DayPilot.Date.today(),
            eventHeight: 45,
            eventMoveHandling: "Disabled",
            eventResizeHandling: "Disabled",
            eventClickHandling: "Enabled",
            timeRangeSelectedHandling: "Disabled",

            onEventClick: (args) => {
                this.loadTherapistWorkDay(args.e.data);
            },

            onBeforeEventRender: (args) => {

                args.data.areas = [
                    {
                        top: 1,
                        right: 1,
                        icon: "fa fa-sort-down",
                        visibility: "Visible",
                        action: "ContextMenu",
                        style: "font-size: 12px; background-color: #f9f9f9; border: 1px solid #ccc; padding: 2px 2px 0px 2px; cursor:pointer;"
                    }
                ];
            },

            contextMenu: this.config.contextMenu
        };

        this.loadLunchEvents();

        if(this.spaInitial != 0 && this.spaInitial != null){
            this.checkSpaExploration(this.spaInitial, false);
        }

    },

    computed: {
        scheduler: function () {
            return this.$refs.scheduler.control;
        },

        calendarDate: function() {
            return this.config.startDate.toString("d MMMM yyyy", "pt-pt");
        },

        spasvg() {
            return this.$store.state.spasvg;
        },
    },

    watch: {
        jumpDate: function(new_val, old_val) {
            if(new_val !== '')  {
                this.config.startDate = DayPilot.Date(new_val.toISOString());
                this.configMonth.startDate = DayPilot.Date(new_val.toISOString());
            }

            if(this.calendarDate != DayPilot.Date.today().toString("d MMM yyyy")){
                this.disButtonBack = false;
            }else{
                this.disButtonBack = true;
            }

            let date = DayPilot.Date(this.config.startDate).toString("yyyy-MM-dd");
            this.loadEvents(this.spaInitial,date);
        },

        spaSelected(new_val,old_val){
            let date = DayPilot.Date(this.config.startDate).toString("yyyy-MM-dd");

            this.loadEvents(this.spaInitial,date);
        },

        spaInitial(new_val,old_val){
            let date = DayPilot.Date(this.config.startDate).toString("yyyy-MM-dd");

            if(old_val === null){
                if(new_val != 0 && new_val != null){
                    this.loadResources(new_val,date);
                }
            }else if(old_val !== null && old_val !== new_val){
                this.loadResources(new_val,date);
            }
            if(new_val != 0 && new_val != null){
                this.checkSpaExploration(new_val, false);
            }
        },

        showModal(new_val,old_val) {
            if(!new_val ){
                this.clearFields();
            }
        },
    },

}
</script>
